import { tokens } from '@/lib/tokens.js';

export function Header() {
  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: tokens.colors.bgDark,
        borderBottom: `1px solid ${tokens.colors.borderDark}`,
        padding: '0 1.5rem',
        height: '56px',
        flexShrink: 0,
      }}
    >
      <a href="/" aria-label="Quartup Reports — Inicio">
        <img src={tokens.logo.dark} alt="Quartup" style={{ height: '28px', display: 'block' }} />
      </a>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          color: tokens.colors.textMutedDark,
          fontSize: '0.875rem',
        }}
      >
        <span>Reports</span>
      </div>
    </header>
  );
}
